module.exports = __webpack_public_path__ + "img/gaoya0.20aa3b96.svg";